export const outcomeGoalMetrics = ["referrals", "careStarts"];
export const outcomeGoalMetricLabels = {
    referrals: "Referrals received",
    careStarts: "Care started",
};
export const outcomeGoalMetricShortLabels = {
    referrals: "Referrals",
    careStarts: "Care started",
};
export const zeroTargets = () => ({
    activity: {},
    referrals: 0,
    careStarts: 0,
});
export const maxMarketingGoalRangeYears = 5;
export const maxMarketingGoalRangeDays = maxMarketingGoalRangeYears * 366;
export const marketingGoalRecentActivityLimit = 10;
export const marketingGoalActivityFeedLimit = 200;
export const maxGoalUpsertMarketers = 100;
export const goalMetricItemLinkKinds = [
    "placement",
    "homeCare",
    "referenceContact",
    "referenceBusiness",
    "community",
];
//# sourceMappingURL=marketing-goal.js.map